/** FollowUpsPageRoute — pass-through; FollowUpsPage owns its masthead. */
import FollowUpsPage from "./FollowUpsPage";

export default function FollowUpsPageRoute() {
  return <FollowUpsPage />;
}
